import { AlignVerticalCenterIcon } from './AlignVerticalCenterIcon';

/**
 * author: Google
 * id 04AE9704-928E-4272-B7FA-BD2ABC38ABE0
 * name align-vertical-center
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/align-vertical-center.svg
 * tags
 */
export const AlignVerticalCentreIcon = AlignVerticalCenterIcon;
export default AlignVerticalCentreIcon